export default function AboutPage() {
  return (
    <div className="min-h-screen bg-cream-50">
      <div className="pt-32 pb-12 md:pt-40 md:pb-16 max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <p className="font-mono text-xs text-stone-400 tracking-[0.25em] uppercase mb-5 whitespace-nowrap">
          Who We Are
        </p>
        <h1 className="font-serif text-5xl md:text-7xl text-charcoal-900 mb-6">
          About U Design
        </h1>
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 pb-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-7">
            <p className="text-lg md:text-xl text-charcoal-800 leading-relaxed mb-8">
              A Melbourne building design studio connecting ideas, documentation, interiors and project delivery.
            </p>
            <p className="text-base text-stone-600 leading-relaxed mb-6">
              With over 15 years of experience working alongside local councils and authorities, we support projects through site assessment, town planning documentation, detailed drawings, project marketing and settlement coordination.
            </p>
            <p className="text-base text-stone-600 leading-relaxed mb-6">
              Many clients juggle a building designer, marketing agency and software contractor. At U Design Studio, those capabilities work together, creating fewer gaps, clearer communication and a smoother path to completion.
            </p>
            <p className="text-base text-stone-600 leading-relaxed">
              Our work spans greater Melbourne and the Yarra Valley — from Mitcham and Ringwood to Toorak, Carlton and Yering. Every project, whether a five-lot townhouse subdivision or a compact cafe fit-out, receives the same attention to detail.
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-cream-100 p-8 md:p-10">
              <h3 className="font-serif text-2xl text-charcoal-900 mb-6">Quick Facts</h3>
              <div className="space-y-6">
                <div>
                  <p className="font-mono text-[10px] text-stone-400 tracking-[0.2em] uppercase mb-1 whitespace-nowrap">Established</p>
                  <p className="text-charcoal-800 text-base">Over 15 years</p>
                </div>
                <div>
                  <p className="font-mono text-[10px] text-stone-400 tracking-[0.2em] uppercase mb-1 whitespace-nowrap">Projects Delivered</p>
                  <p className="text-charcoal-800 text-base">30+ across Melbourne</p>
                </div>
                <div>
                  <p className="font-mono text-[10px] text-stone-400 tracking-[0.2em] uppercase mb-1 whitespace-nowrap">Specialisation</p>
                  <p className="text-charcoal-800 text-base">Residential subdivisions, commercial fit-outs, project delivery</p>
                </div>
                <div>
                  <p className="font-mono text-[10px] text-stone-400 tracking-[0.2em] uppercase mb-1 whitespace-nowrap">Coverage</p>
                  <p className="text-charcoal-800 text-base">Greater Melbourne &amp; Yarra Valley</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
